import React, { useState } from 'react';
import './FilterButton.css'

export default function FilterButton({arr, setMainArr}) {

  
  const Types = ["All",...new Set(arr.map((item) => item.type))]
  let [categories, setCategories] = useState(Types)

const filterButtons = (type) => {
  if (type === "All") {
    setMainArr(arr)
    return
  }

  const newitems = arr.filter((item) => {
    return item.type === type
  })

  setMainArr(newitems)
}

  return (
    <div className='buttons'>
      {categories.map((type, i) =>{
    return <button key={i} className="filter-btn" onClick={()=> filterButtons(type)}>{type}</button>
      })}
    </div>
  )
}
